module.exports = __webpack_public_path__ + "static/media/MyProfile@3x.5675487d.png";